import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { takeUntil } from 'rxjs/operators';
import { ApiService } from '../../services/api.service';
import { UnsubscribeComponent } from '../../generals/Components';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent extends UnsubscribeComponent {

  loading = false;

  logout(): void {
    this.loading = true;
    this.apiService.logout().pipe(takeUntil(this.unsubscribe)).subscribe(() => {
      this.userService.userData = null;
      this.router.navigateByUrl('/login');
      this.close();
    }).add(() => {
      this.loading = false;
    });
  }

  close(result: boolean = false): void {
    this.ref.close(result);
  }

  constructor(
    private ref: DynamicDialogRef,
    private apiService: ApiService,
    private userService: UserService,
    private router: Router
  ) {
    super();
  }
}
